import {
  useQuery,
  UseQueryResult,
  UseQueryOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import { DuesSettingsDto, ResponseDto } from "@mimber/schema"
import { duesKeys } from "../dues.utils"

export const useDuesSettings = (
  options?: UseQueryOptions<ResponseDto<DuesSettingsDto>, Error>
): UseQueryResult<ResponseDto<DuesSettingsDto>, Error> => {
  guardAppUsage("mimber-organization", "useDuesSettings")

  const { server } = useServerContext()

  return useQuery({
    queryKey: duesKeys.getSettings(),
    queryFn: async () => {
      const response =
        await server.get<ResponseDto<DuesSettingsDto>>("dues/settings")
      return response.data
    },
    staleTime: 5 * 60 * 1000,
    ...options,
  })
}
